// extracted by mini-css-extract-plugin
export default {"reports":"Customer_reports__nT88W"};